import { render, staticRenderFns } from "./SoftwareVersionRow.vue?vue&type=template&id=6cc84af2&"
import script from "./SoftwareVersionRow.vue?vue&type=script&lang=ts&"
export * from "./SoftwareVersionRow.vue?vue&type=script&lang=ts&"
import style0 from "./SoftwareVersionRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDialog,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cc84af2')) {
      api.createRecord('6cc84af2', component.options)
    } else {
      api.reload('6cc84af2', component.options)
    }
    module.hot.accept("./SoftwareVersionRow.vue?vue&type=template&id=6cc84af2&", function () {
      api.rerender('6cc84af2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/SoftwareVersionRow.vue"
export default component.exports